<p-table 
    #table 
    [loading]="loading" 
    [value]="personale" 
    responsiveLayout="stack" 
    [breakpoint]="'960px'"
    styleClass="scheda-tabella p-datatable-sm" 
    [paginator]="false" 
    [showCurrentPageReport]="true" 
    [rowHover]="true" 
    dataKey="id"
    [expandedRowKeys]="expandedRows"
    [globalFilterFields]="['nome', 'cognome', 'ruolo']" 
    currentPageReportTemplate="{first} di {last} su {totalRecords} membri del personale" 
    [rows]="100" [rowsPerPageOptions]="[5, 10, 20, 50, 100]">            
    <ng-template pTemplate="caption">           
        <div class="flex lg:flex-row flex-col gap-3 w-full">
            <div class="lg:w-2/4 w-full">
                <p-iconfield iconPosition="left" [style]="{'width': '100%'}">
                    <p-inputicon styleClass="bi bi-search" />
                    <input type="text" pInputText (input)="onGlobalFilter(table, $event)" placeholder="Cerca personale…" [style]="{'width': '100%'}" />
                </p-iconfield>
            </div>
            <div class="lg:w-2/4 w-full table-toolbar-btns">    
                @if (!visione) {
                    <button class="flex-1 acc-btn" type="button" (click)="add = true">                
                        <i class="bi bi-plus"></i>
                        Aggiungi
                    </button>
                }
                <button class="flex-1 acc-btn" type="button" (click)="onBadgePersonale()">                
                    <i class="bi bi-person-badge-fill"></i>
                    Badge
                </button>
                <button class="flex-1 acc-btn" type="button" (click)="onDownloadDocumenti()">                
                    <i class="bi bi-file-zip-fill"></i>
                    Scarica
                </button>
                <button class="flex-1 acc-btn" type="button" (click)="onExport()">                
                    <i class="bi bi-file-spreadsheet"></i>
                    Esporta
                </button>
            </div>
        </div>                   
    </ng-template>
    <ng-template pTemplate="header">
        <tr>              
            <th pSortableColumn="cognome">Cognome e Nome <span class="inline-flex"><p-sortIcon field="cognome" /></span></th>
            <th pSortableColumn="ruolo">Ruolo <span class="inline-flex"><p-sortIcon field="ruolo" /></span></th>                            
            <th>Agibilità INPS</th>
            <th>Attestati / abilitazioni</th>            
            <th>Unilav</th>
            <th class="text-center">Azioni</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-persona let-expanded="expanded">
        <tr>
            <td>
                <span class="p-column-title">Cognome e Nome</span>
                <span class="cell-nome">{{persona.cognome}} {{persona.nome}}</span>
            </td>            
            <td>
                <span class="p-column-title">Ruolo</span>
                <span class="cell-meta" style="margin:0;font-size:13px;color:#3D3D3D">{{persona.ruolo}}</span>
            </td>            
            <td>
                <span class="p-column-title">Agibilità INPS</span>
                <span class="mini-pill" [class.ok]="persona.inps" [class.crit]="!persona.inps">{{ persona.inps ? 'Si' : 'No' }}</span>
            </td>
            <td>
                <span class="p-column-title">Attestati / abilitazioni</span>
                @if (checkDocumenti('certificazione', persona) > 0) {
                    <a class="mini-pill wait cursor-pointer" (click)="onDownloadDocumentiPersonaleDettaglio(persona, 'certificazione')">
                        {{ checkDocumenti('certificazione', persona) }} file
                    </a>
                } @else {
                    <span class="mini-pill na">—</span>
                }
            </td>            
            <td>
                <span class="p-column-title">Unilav</span>
                @if (checkDocumenti('unilav', persona) > 0) {
                    <span class="mini-pill wait cursor-pointer" (click)="onDownloadDocumentiPersonaleDettaglio(persona, 'unilav')">
                        {{ checkDocumenti('unilav', persona) }} file
                    </span>
                } @else {
                    <span class="mini-pill na">—</span>
                }
            </td>
            <td class="text-center">
                <span class="p-column-title">Azioni</span>                
                <div class="table-actions">      
                    <i class="bi bi-pencil" (click)="onOpenEdit(persona)" title="Modifica"></i>                        
                    <p-divider layout="vertical"></p-divider>                    
                    <i class="bi bi-person-badge-fill" (click)="onBadge(persona)" title="Badge"></i>                                        
                    <p-divider layout="vertical"></p-divider>
                    <i class="bi bi-file-zip-fill" (click)="onDownloadDocumentiPersonale(persona)" title="Scarica"></i>                    
                    <p-divider layout="vertical"></p-divider>
                    <p-confirmPopup #delete>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <button type="button" class="acc-btn acc-btn-ghost flex-1"  (click)="onClose()">Annulla</button>
                                    <button type="button" class="acc-btn flex-1" (click)="onDelete()">Elimina</button>                                        
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmPopup>
                    <i class="bi bi-trash" (click)="onOpenDelete($event, persona)" title="Elimina"></i>                                    
                </div>
            </td>
        </tr>
    </ng-template>    
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="7">Nessun membro del personale trovato.</td>
        </tr>
    </ng-template>
</p-table>

<app-add-personale-accrediti-backoffice [visible]="add" [attivita_rischio]="attivita_rischio || false" [evento]="evento" (close)="add = false" />
<app-edit-personale-accrediti-backoffice *ngIf="persona" [visible]="edit" [attivita_rischio]="attivita_rischio || false" [persona]="persona" [evento]="evento" (close)="onCloseEdit($event)" />

<app-loading-backoffice [visible]="loading"></app-loading-backoffice>
